import HasNoBankAccount from 'components/UI/layout/components/emergencyInfos/HasNoBankAccount';
import HasNoCustomer from 'components/UI/layout/components/emergencyInfos/HasNoCustomer';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

const EmergencyInfos: FC = () => {
  //state
  const { hasCustomer, hasBankAccount } = useSelector((state: RootState) => state.user.userAllowed);

  if (hasCustomer && hasBankAccount) return null;
  return (
    <div className='flex justify-end gap-2'>
      {/* <HasNoCustomer /> */}
      {!hasCustomer && <HasNoCustomer />}
      {!!hasCustomer && !hasBankAccount && <HasNoBankAccount />}
    </div>
  );
};

export default EmergencyInfos;
